import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Coffee.es.js";
const o = e.forwardRef((f, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...f, weights: a }));
o.displayName = "CoffeeIcon";
const s = o;
export {
  s as Coffee,
  o as CoffeeIcon
};
